/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import Skeleton from '@atlaskit/skeleton';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { AvailableAgentsTableSkeleton } from './AvailableAgentsTableSkeleton.tsx';

const loadingMessage = defineMessage({
	id: 'servicedesk-availability.page-skeleton.loading',
	defaultMessage: 'Loading availability',
	description: 'Accessible loading message for screen readers while availability page is loading',
});

export const AvailabilityPageSkeleton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.400" testId="availability.ui.availability-page-skeleton">
			<VisuallyHidden>{formatMessage(loadingMessage)}</VisuallyHidden>

			{/* 3 Stat Card Skeletons */}
			<Inline space="space.200">
				<Skeleton height="64px" width="100%" />
				<Skeleton height="64px" width="100%" />
				<Skeleton height="64px" width="100%" />
			</Inline>

			{/* Filters Skeleton */}
			<Skeleton height="35px" width="308px" />

			{/* Table Skeleton */}
			<AvailableAgentsTableSkeleton rowCount={5} />
		</Stack>
	);
};
